const formatUserInfoValue = (value) => {
  return value ? value : '--'
}

export default formatUserInfoValue
